<sui-dialog-tabs class="no-aside-padding">
  <ng-template suiDialogRightHeader>
    <div class="right-header-content">
      @if (objectIcon) {
        <fa-icon [icon]="objectIcon"></fa-icon>
      }
      <h2 ngpDialogDescription>{{ objectNameTitle }}</h2>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogRightContent>
    <div class="wizard">
      <div class="steps">
        <app-wizard-steps
          [steps]="wizardSteps"
          [currentStep]="currentStep"
        ></app-wizard-steps>
      </div>
      <div
        class="wizard-step"
        [ngClass]="{
          step1: currentStep == 0,
          step2: currentStep == 1,
          step3: currentStep == 2,
          step4: currentStep == 3,
        }"
      >
        <ng-container #tabHost></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template suiDialogRightFooter>
    <div class="right-footer-wrapper">
      @for (button of buttons; track button.text) {
        <sui-button
          [variant]="button.variant || 'secondary'"
          [leadingIcon]="button.leadingIcon"
          [disabled]="button.disabled"
          [loading]="button.loading"
          (click)="button.action()"
        >
          {{ button.text }}
        </sui-button>
      }
    </div>
  </ng-template>
</sui-dialog-tabs>
